import { ChevronRightIcon } from '@/components/icons';
import type { ApiPaginationMeta } from '@/lib/api';

interface PaginationProps {
  meta?: ApiPaginationMeta;
  count: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
}

/** Pied de liste : compteurs réels de l'API et navigation sans saut de largeur. */
export const Pagination = ({ meta, count, onPageChange, loading = false }: PaginationProps) => {
  if (!meta || meta.total === 0) return null;
  const first = count ? (meta.page - 1) * meta.limit + 1 : 0;
  const last = count ? first + count - 1 : 0;

  return (
    <div className="border-navy-100 flex shrink-0 flex-wrap items-center justify-between gap-2 border-t bg-white px-4 py-3">
      <p className="text-ink-500 text-xs tabular-nums" aria-live="polite">
        <span className="text-navy-900 font-medium">
          {first}–{last}
        </span>{' '}
        sur {meta.total.toLocaleString('fr-FR')}
      </p>
      {meta.totalPages > 1 ? (
        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="Page précédente"
            disabled={loading || !meta.hasPreviousPage}
            onClick={() => onPageChange(meta.page - 1)}
            className="border-navy-200/80 text-navy-700 enabled:hover:bg-navy-50 focus-visible:ring-accent-700/25 grid size-8 cursor-pointer place-items-center rounded-lg border bg-white text-sm shadow-[inset_0_1px_0_0_rgb(255_255_255/0.95),0_1px_2px_rgb(15_42_95/0.04)] focus-visible:ring-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-40"
          >
            <ChevronRightIcon className="rotate-180" />
          </button>
          <span className="text-ink-500 text-xs tabular-nums">
            {meta.page} / {meta.totalPages}
          </span>
          <button
            type="button"
            aria-label="Page suivante"
            disabled={loading || !meta.hasNextPage}
            onClick={() => onPageChange(meta.page + 1)}
            className="border-navy-200/80 text-navy-700 enabled:hover:bg-navy-50 focus-visible:ring-accent-700/25 grid size-8 cursor-pointer place-items-center rounded-lg border bg-white text-sm shadow-[inset_0_1px_0_0_rgb(255_255_255/0.95),0_1px_2px_rgb(15_42_95/0.04)] focus-visible:ring-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-40"
          >
            <ChevronRightIcon />
          </button>
        </div>
      ) : null}
    </div>
  );
};
